import modelBaseV2 from '../../models/model-base-v2.model';
import moment from "moment";

/**
 * Model Mapping Model
 * 
 * Contains all the requests used by Model Mapping
 * 
 * @author cmc.pbhieu
 */

let ModelMappingModel = {
  search: (body) => {
    return modelBaseV2.post('/api/intf-edi/modelMappings/search', { body });
  },

  manage: (data, action) => {
    const body = { action, ...data };
    return modelBaseV2.post('/api/intf-edi/modelMappings/manage', { body });
  },

  uploadExcel: (file) => {
    const body = new FormData();
    body.append('uploadedExcel', file);

    return modelBaseV2.post('/api/intf-edi/modelMappings/excelUpload', { body });
  },

  downloadExcelTemplate: (body) => {
    return modelBaseV2.postDownload(
      "/api/executesp/export/commontemplateremark",
      { body },
      `model_mapping_${moment().format('YYYYMMDDHHmm')}.xlsx`
    );
  },

  downloadResult: (fileId, filename) => {
    return modelBaseV2.getDownload(
      "/api/file/temp/:fileId",
      {
        params: { fileId },
      },
      filename
    );
  },

  downloadModelMappingExcel: (filters) => {
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      sortBy: "24",
      customerCode: "81",
      mapKey: "82",
      mapAttribute1: "83",
      mapAttribute2: "84",
    }

    const downloadExcelFilters = { ...filters, pageSize: 0 }

    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let attr = downloadExcelFilters[key];

      return {
        code: value,
        value: attr
          ? Array.isArray(attr)
            ? attr.join('^')
            : attr.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "INTF Model Mapping List",
        "INTF Model Mapping Count"
      ],
      storedProcedureCode: "43",
      params
    }

    return modelBaseV2.postDownload(
      '/api/executesp/export/commonexcel',
      { body: exportConfig },
      `MODEL_MAPPING_${moment().format('YYYYMMDDHHmm')}.xlsx`);
  }
}

export default ModelMappingModel;